import { Component, input } from '@angular/core';

@Component({
  selector: 'app-sidepanel-description',
  imports: [],
  template: `<div [innerHTML]="value()"></div>`,
  host: {
    class: 'text-content-secondary paragraph-medium-medium',
  },
})
export class SidepanelDescriptionComponent {
  readonly value = input.required<string>();
}
